import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const ButtonGroup = (props) => {
    const { children, ...other } = props;
    return React.createElement(ButtonGroupStyled, { ...other }, children);
};
export default ButtonGroup;
const ButtonGroupStyled = styled.div `
  display: inline-block;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);

  .btn {
    border-radius: 0;
    box-shadow: inset 1px 0px 0px 0px rgba(0, 0, 0, 0.2);

    &:first-child {
      box-shadow: none;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    ${(props) => props.blockOnMobile
    ? `
      display: block;
      width: 100%;
      `
    : ''}
  }
`;
//# sourceMappingURL=ButtonGroup.js.map